// extracted by mini-css-extract-plugin
module.exports = {"root":"ReserveInfo_root__hmyCy","content":"ReserveInfo_content__2oKF2","percent":"ReserveInfo_percent__2otWk","usd":"ReserveInfo_usd__kQoIk"};